var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"downloadapp","src":require("@/assets/downloadapp.jpg")},on:{"click":_vm.moveToApp}}),_c('Copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }